






















































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import { SelectItem } from "@/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class BasicInfo6 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() beppyou_items!: SelectItem[]; //別表選択アイテムリスト

  @Emit("openDialog")
  openDialog() {
    return;
  }

  //NumberInputなので以下処理必須
  get NoticesGafPoints() {
    return this.tab.notices_gaf_points;
  }
  set NoticesGafPoints(newValue: string) {
    if (newValue == null) {
      this.tab.notices_gaf_points = "";
    } else {
      this.tab.notices_gaf_points = String(newValue);
    }
  }
}
